export default __webpack_public_path__ + "static/1-3997b422f32df58386c7d384fce73f87.jpg";